/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

const COMPANY_LEVEL_PROJECT_ID = 1;
const HOME_PAGE_ID = '-1000';
const DEFAULT_HOME_NAME = '';
const FROM_SUB_PAGE_BOOKMARK = true;

export class NavRoutingHandler {

    constructor(navMainHandle, isFromBrowserAction) {
        this.navMainHandle = navMainHandle;
        this.isFromBrowserAction = isFromBrowserAction;
    }

    handle() {

        //If no location hash just navigate to home.
        if (!window.location || window.location.hash.length < 1) {
            this._handleNoHashHomeRoute();
            return;
        }
        
        //Parse location hash to route page.
        let queryString = window.location.hash;

        //First attempt to handle sub page bookmark
        if (this.isSubPageBookmark(queryString)) {
            this._handleSubPageBookmark();
            return;
        }

        let queryStringArray = queryString.split('?project=');
        if (queryStringArray.length > 1) {
            let projectPart = queryStringArray[1].replace('?project=');
            let projectId = projectPart.split('&')[0];
            let routePageName = queryStringArray[0].replace('#','');
            routePageName = this._handleRoutingPageNameForLegacyBookmark(routePageName);
            this.navMainHandle.switchProjectAndSelectProjectMenuItem(projectId, routePageName,
                            this.isFromBrowserAction);
        } else {
            queryStringArray = queryString.split("&project=");
            if (queryStringArray.length > 1) {
                let projectPart = queryStringArray[1].replace('&project=');
                let projectId = projectPart.split('&')[0];
                let menuNamePartArray = queryStringArray[0].split('?');
                let routePageName = menuNamePartArray[0].replace('#','');
                routePageName = this._handleRoutingPageNameForLegacyBookmark(routePageName);
                this.navMainHandle.switchProjectAndSelectProjectMenuItem(projectId, routePageName, 
                                this.isFromBrowserAction);
            } else {
                let routePageName = queryString.split('?')[0];
                routePageName = this._handleRoutingPageNameForLegacyBookmark(routePageName);
                //If the hash is just pointing to project the default should be the project homepage.
                if (routePageName.startsWith('#project=')) {
                    let projectId = routePageName.replace('#project=','');
                    this.navMainHandle.switchProjectAndSelectProjectMenuItem(projectId, DEFAULT_HOME_NAME, 
                        this.isFromBrowserAction);
                } else {
                    routePageName = routePageName.replace('#','');
                    let menuId = this.navMainHandle.hierarchyListItemHandler.getListItemIdByName(routePageName);
                    this.navMainHandle.navButtonClickFromCompanyContext(menuId, this.isFromBrowserAction);
                }
            }
        }
    }

    getNameFromParent(queryString) {
        if (this._doesQueryStringIncludeParent(queryString)) {
            return this.getQueryStringParamValue(queryString, 'parent', DEFAULT_HOME_NAME);
        } else {
            //Default to returning name from name, if parent not included as query param.
            return this.getNameFromName(queryString);
        }
    }

    getNameFromName(queryString) {
        return this.getQueryStringParamValue(queryString, 'name', DEFAULT_HOME_NAME);
    }

    getProjectId(queryString) {
        return this.getQueryStringParamValue(queryString, 'project', COMPANY_LEVEL_PROJECT_ID);
    }

    getQueryStringParamValue(queryString, param, defaultValue) {
        let queryStringArray = queryString.split('?'+param+'=');
        if (queryStringArray.length > 1) {
            let paramPart = queryStringArray[1];
            return paramPart.split('&')[0];
        } else {
            queryStringArray = queryString.split('&'+param+'=');
            if (queryStringArray.length > 1) {
                let paramPart = queryStringArray[1];
                return paramPart.split('&')[0];
            } else {
                queryStringArray = queryString.split('#'+param+'=');
                if (queryStringArray.length > 1) {
                    let paramPart = queryStringArray[1];
                    return paramPart.split('&')[0];
                }
            }
        }
        return defaultValue;
    }

    isSubPageBookmark(queryString) {
        if (this._doesQueryStringIncludeParent(queryString)) {
           return true;
        } else if (!this._isNameFromNameValid(queryString)) {
            //If name from name is not valid, handle as a sub page bookmark
            return true;
        }
        return this._isSystemManagedPageBookmark(queryString);
    }

    _isNameFromNameValid(queryString) {
        let name = this.getNameFromName(queryString);
        if (name.length > 0) {
            let menuId;
            if (this.isProjectContext(queryString)) {   
                menuId = this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.getListItemIdByName(name);
            } else {  
                menuId = this.navMainHandle.hierarchyListItemHandler.getListItemIdByName(name);
            }
            //Check if menu id exists.
            if (!menuId) {
                return false;
            }
        }
        return true;
    }

    _doesQueryStringIncludeParent(queryString) {
        return queryString.includes("&parent=") ||
                queryString.includes("?parent=") ||
                queryString.includes("#parent=");
    }

    _isSubPageQueryString(queryString) {
        return this._doesQueryStringIncludeParent(queryString);
    }

    //Handle any system manage page bookmarks. So far only sysMyProfile.
    _isSystemManagedPageBookmark(queryString) {
        let pageName = this.getNameFromName(queryString);
        if (pageName === "sysMyProfile") {
            return true;
        }
        return false;
    }

    isProjectContext(queryString) {
        if (queryString.includes("&project=") ||
                queryString.includes("?project=") ||
                queryString.includes("#project=")) {
            
           return true;
        }
        return false;
    }

    handleRoutingHistory(name, queryString, isFromBrowserAction) {
        //Browser history
        if (!isFromBrowserAction) {
            //Make sure query string includes hash.
            if (!queryString.includes('#')) {
                queryString = queryString + '#';
            }

            //Set browser history for routing purposes.
            let routingObj = { title: name, url: queryString }; 
            window.history.pushState(routingObj, routingObj.title, routingObj.url);  
        }
    }

    _handleSubPageBookmark() {
        let queryString = window.location.hash;
        this.navMainHandle.handleNavFrameSourceForSubPage('/html/en/default/platform/mainpagepopout/mainpagepopout.jsp'+queryString,
            this.getNameFromParent(queryString),
            FROM_SUB_PAGE_BOOKMARK,
            this.isProjectContext(queryString),
            this.getProjectId(queryString),
            this.isFromBrowserAction
       );
    }

    _handleRoutingPageNameForLegacyBookmark(routePageName) {
        return routePageName.replace('name=', '');
    }

    _handleNoHashHomeRoute() {
        //This will navigate to company context home, no project
        this.navMainHandle.navButtonClickFromCompanyContext(HOME_PAGE_ID, this.isFromBrowserAction);
    }

    handleQueryStringForCurrentProjectId(queryString) {
        if (this._getCurrentProjectContainer().isCurrentProjectAtProjectLevelContext()) {
          let queryParamSeparator = queryString.includes('#') ? '&': '#';
          queryString = queryString + queryParamSeparator + 'project='+this._getCurrentProjectContainer().state.currentProjectId;
        }
        return queryString;
    }

    handleActiveMenuItemForQueryString(queryString) {
        //Handle blue vertical line for respective active menu item.
        this.handleActiveMenuItem(this.getNameFromParent(queryString), queryString);
    }

    handleActiveMenuItem(menuItemName, queryString) {
      //Handle blue vertical line for respective active menu item.
      if (this._getCurrentProjectContainer().isCurrentProjectAtProjectLevelContext()) {
          let menuItemId = this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.getListItemIdByName(menuItemName);
          let menuItem = this._getCurrentProjectContainer().projectContainerHierarchyListItemHandler.handleValidMenuItem(menuItemId);
          this._getCurrentProjectContainer().activeProjectSubMenuItemHandler.handle(menuItem.id);
      } else {
          let menuItemId = this.navMainHandle.hierarchyListItemHandler.getListItemIdByName(menuItemName);
          let isRootMenuItemValid = true;
          let isParentHome = false;
          if (!menuItemId && queryString && this._doesQueryStringIncludeParent(queryString)) {
            //See if we can use breadcrumb from name
            menuItemName = this.getNameFromName(queryString);
            menuItemId = this.navMainHandle.hierarchyListItemHandler.getListItemIdByName(menuItemName);
            isRootMenuItemValid = false;
          } else if (!menuItemId) {
            //Default menuItem to home page
            menuItemId = HOME_PAGE_ID;
            if (menuItemName !== DEFAULT_HOME_NAME) {
              isParentHome = true;
            }
          }
          this.navMainHandle.activeMenuItemHandler.handle(menuItemId);

          //Handle project header link rendering
          this.navMainHandle.projectContextService.hideProjectRenderingForCompanyLevelMenuItem(menuItemName);

          //Current page handling that is necessary for sub page breadcrumb.
          if ((queryString && this._isSubPageQueryString(queryString) && isRootMenuItemValid) || isParentHome) {
              this._getCurrentProjectContainer().handleCurrentSelectedMenuItemIdForSubPage(menuItemId);
          } else {
              this._getCurrentProjectContainer().handleCurrentSelectedMenuItemIdNotSubPage(menuItemId);
          }
      }
  }

    _getCurrentProjectContainer() {
        return this.navMainHandle.projectContainer.current;
    }
}